import { useTranslation } from 'react-i18next';

import { createFileRoute } from '@tanstack/react-router';

import { StandardLayoutView } from '@optiro/ui';

import { ProjectFeedbackReportsView } from '@/modules/ProjectFeedbackReports';

export const Route = createFileRoute('/app/reports/feedback/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('reports');

  return (
    <StandardLayoutView title={t('feedback.card_title')}>
      <ProjectFeedbackReportsView />
    </StandardLayoutView>
  );
}
